export const isStaging = () => {
    var name = window.location.hostname;
    if (name === "localhost" || name === "sg.clikpa.com" || name === "my.clikpa.com" || name === "in.clikpa.com") {
        return true;
    }
    return false;
};
